import { camelCase } from 'lodash-es';
import { useTranslation } from 'next-i18next/pages';
import { useCallback } from 'react';

import { JobTitle, RequiredJobTitle } from '@pflegia/types/api/job-title';
import { JOB_TITLES_WITH_SHORT_FORMS } from '@pflegia/types/api/job-title/constants';

const useJobTitle = (translationKey = 'jobTitles') => {
  const { t } = useTranslation(translationKey);
  const translateJobTitle = useCallback(
    (baseJobTitle?: Pick<JobTitle, 'deputy' | 'title'>, shouldShortLabel = false) => {
      const jobTitle = baseJobTitle as RequiredJobTitle;
      if (!jobTitle) return '';
      let key: string = jobTitle.title;
      if (shouldShortLabel && JOB_TITLES_WITH_SHORT_FORMS[jobTitle.title]) {
        key = JOB_TITLES_WITH_SHORT_FORMS[jobTitle.title];
      }
      const title = t(camelCase(key));
      const fullTitle = jobTitle.deputy ? `${t('deputy')} ${title}` : title;

      return fullTitle;
    },
    [t],
  );
  return { translateJobTitle };
};

export default useJobTitle;
